module.exports = __webpack_public_path__ + "static/media/Surrounding1.2c3ba0d7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding1.jpeg
// module id = 574
// module chunks = 0